import { Modal } from 'antd'
import styled from 'styled-components'

export const ListHistoryLogModalWrapper = styled(Modal)`
  .ant-modal-body {
    background-color: #fbfbfb;
  }
`
